import { DashboardTicketsPage } from '@pages/Admin/DashboardErrorTickets/pages/DashboardErrorPage';

export const DashboardErrorTickets = () => {
  return <DashboardTicketsPage />;
};
